// libs
import { styled } from '@nykaa/ui-components';

//components
import FilterCheckboxBase from 'shared/components/Filter/components/FilterCheckbox';

// mixins
import { truncate } from 'shared/styles/mixin';

export const CategoryList = styled.div<{ level: string; }>`
  width: 300px;
  max-height: 50vh;
  overflow: scroll;
  ${({ level, theme }) =>
    level !== '' && `border-left: ${theme.spacing.spacing10} solid ${theme.colors.surface20}`};
`;

export const Option = styled.div<{ isSelected: boolean; }>`
  padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing80}`};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  ${({ isSelected, theme }) =>
    !isSelected &&
    `&:hover {
    background-color: ${theme.colors.filterHover};
  }`};
  ${({ isSelected, theme }) => isSelected && `background-color: ${theme.colors.filterSelected}`};
`;

export const RightArrow = styled.div`
  display: inline-flex;
`;

export const OptionInfo = styled.div`
  display: flex;
  align-items: end;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};
  ${truncate};
`;

export const Count = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: ${({ theme }) => `${theme.spacing.spacing0} ${theme.spacing.spacing40}`};
  padding-top: ${({ theme }) => theme.spacing.spacing10};
  ${({ theme }) => theme.typography.bodySmall};
  align-self: center;
`;

export const FilterCheckbox = styled(FilterCheckboxBase)`
  padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing80}`};
`;
